import { useState, useEffect } from 'react';
import { getUserTimezone } from '../utils/timezone.utils';

/**
 * Custom hook for managing user timezone preference
 * Listens to timezone changes and triggers re-renders
 * @returns {string} Current user timezone (IANA format)
 */
export const useTimezone = () => {
    const [timezone, setTimezone] = useState(() => getUserTimezone());

    useEffect(() => {
        // Listen for timezone changes
        const handler = (e) => {
            if (e.detail?.timezone) {
                setTimezone(e.detail.timezone);
            } else {
                // Fallback: read from localStorage
                setTimezone(getUserTimezone());
            }
        };
        
        window.addEventListener('tb:timezoneChanged', handler);
        
        // Also check localStorage periodically (in case changed elsewhere)
        const interval = setInterval(() => {
            const currentTz = getUserTimezone();
            if (currentTz !== timezone) {
                setTimezone(currentTz);
            }
        }, 1000); // Check every second
        
        return () => {
            window.removeEventListener('tb:timezoneChanged', handler);
            clearInterval(interval);
        };
    }, [timezone]);

    return timezone;
};

